
import {Injectable} from '@angular/core';
import {Product, TrackingObject} from "./track-object";
import {HttpParams} from "@angular/common/http";
import {ActivatedRoute, Router} from "@angular/router";

export interface AllianzTrackingLibraryWindow extends Window {
  digitalDataLayer: any;
}

@Injectable({
  providedIn: 'root'
})


export class TrackingService {
  public trackingObject: TrackingObject;
  public ls_name: string = '';
  public ls_type: string = 'GeneralAgentur';
  public ls_campaign: string = '';
  public ls_kunde: string = '';
  public ls_src: string = '';
  public ls_origin: string = '';
  public ls_werber: string = '';
  public ontrsustChecked = false;

  constructor(private router: Router, private route: ActivatedRoute) {
    // @ts-ignore
    console.log('####', window.digitalDataLayer);

    this.ls_name = localStorage.getItem('_azch_elvia_data_mm_as') || '';
    this.ls_werber = localStorage.getItem('_azch_elvia_data_mm_we') || '';
    this.ls_campaign = localStorage.getItem('_azch_elvia_data_mm_campaign') || '';
    this.ls_kunde = localStorage.getItem('_azch_elvia_data_mm_nr') || '';
    this.ls_src = localStorage.getItem('_azch_elvia_data_mm_sc') || '';


    // @ts-ignore
    this.trackingObject = new TrackingObject();
    this.trackingObject.application.applicationId = "allianz-lead-fw";
    this.trackingObject.application.applicationName = "Allianz Lead Forwarding";
    this.trackingObject.application.virtualPageName = "start";
    this.trackingObject.application.startType = 'default';

    let tempString = new HttpParams({fromObject: this.route.snapshot.queryParams}).toString();
    this.trackingObject.page.pageInfo.URLqueryParams = (tempString.length > 1) ? '?' + tempString : '';
    this.trackingObject.page.pageInfo.fullURL = window.location.href;
    this.trackingObject.page.pageInfo.hostname = window.location.hostname;
    this.trackingObject.page.pageInfo.language = 'de';
    // this.trackingObject.page.pageInfo.pageHash = route.snapshot.fragment;
    this.trackingObject.page.pageInfo.pageName = 'lf2024.lespals.com/' + this.trackingObject.application.virtualPageName
    // console.info('  this.trackingObject.page.pageInfo.URLqueryParams:', route.snapshot.fragment)
    // @ts-ignore
    window.digitalDataLayer.push(this.trackingObject);

  }

  trackConfiguration(type_: string) {
    // console.info('####trackConfiguration', type_);
    this.trackingObject.product.subCategory = type_;
    // @ts-ignore
    window.digitalDataLayer.push(this.trackingObject);
  }

  trackAgent() {
    if (!this.ontrsustChecked) {
      setTimeout(() => {
        // @ts-ignore
        _satellite.track("DCR: Consultation Start");
      }, 1000); // 1000 milliseconds = 1 second



      this.ontrsustChecked = true;
      // @ts-ignore
      let tempCampaign = (window.s.campaign)? window.s.campaign : undefined;
      if (tempCampaign != undefined && tempCampaign != '') {
        // Split the string by '|'
        const pairs = tempCampaign.split('|');

// Loop through the pairs and find the value of 'sc'
        pairs.forEach((pair: { split: (arg0: string) => [any, any]; }) => {
          const [key, value] = pair.split(':');
          if (key === 'as') {
            if (this.ls_name === '') this.ls_name = value;
          }
          if (key === 'we') {
            if (this.ls_werber === '') this.ls_werber = value;
          }
          if (key === 'sc') {
            if (this.ls_src === '') this.ls_src = value;
          }
          if (key === 'cp') {
            if (this.ls_campaign === '') this.ls_campaign = value;
          }
        });
      }
    }

    if (localStorage.getItem('_azch_elvia_data_mm_as') === undefined) localStorage.setItem('_azch_elvia_data_mm_as', this.ls_name);
    if (localStorage.getItem('_azch_elvia_data_mm_sc') === undefined) localStorage.setItem('_azch_elvia_data_mm_sc', this.ls_src);
    // if (localStorage.getItem('_azch_elvia_data_mm_as') != undefined) localStorage.setItem('_azch_elvia_data_mm_as', this.ls_name);
    // @ts-ignore
    window.digitalDataLayer.push({
      leads: {
        origin:this.ls_origin,
        intermediary: {
          name: this.ls_name,
          type: ((this.ls_name!='')?'GeneralAgentur':''),
          werber: this.ls_werber
        },
        campaign: {
          name: this.ls_campaign,
          source: this.ls_src
        },
        user:{
          customerNumber: this.ls_kunde
        }

      },
    });
    var dataLayerEvent = {
      event: {
        eventInfo: {
          eventAction: "page load",
          eventName: "generic",
          eventType: "page"
        },
        category: {
          primaryCategory: "calculator"
        },
        attributes: {
          linkText: "",
          currentURL: window.location.href,
          targetURL: "",
          elementName: "",
          value: "",
          pos: "",
          componentPath: "",
          clickID: ""
        }
      }
    };
    // @ts-ignore
    // window.digitalDataLayer.push(dataLayerEvent);
    // console.log('LEAD TRACKED')!

  }

  trackStep(start: string) {
    // if (start === 'vehicledetails' && !this.ontrsustChecked) {
    this.trackAgent();

    // }
    /* if (start === 'vehicledetails' && !this.ontrsustChecked) {
       this.ontrsustChecked = true;
       // @ts-ignore
       let tempCampaign = window.s.campaign;
       if (tempCampaign != undefined && tempCampaign != '') {
         // Split the string by '|'
         const pairs = tempCampaign.split('|');

 // Loop through the pairs and find the value of 'sc'
         pairs.forEach((pair: { split: (arg0: string) => [any, any]; }) => {
           const [key, value] = pair.split(':');
           if (key === 'as') {
             if (this.ls_name === '') this.ls_name = value;
           }
           if (key === 'we') {
             if (this.ls_werber === '') this.ls_werber = value;
           }
           if (key === 'sc') {
             if (this.ls_src === '') this.ls_src = value;
           }
           if (key === 'cp') {
             if (this.ls_campaign === '') this.ls_campaign = value;
           }
         });
       }

       console.log('tempCampaign', tempCampaign);
     }*/

    this.trackingObject.application.virtualPageName = '' + start;
    this.trackingObject.page.pageInfo.pageName = 'lf2024.lespals.com/' + this.trackingObject.application.virtualPageName

    // console.info('####TRACK: 2', start);

    // @ts-ignore
    window.digitalDataLayer.push(this.trackingObject);

// event comes always at last
    var dataLayerEvent = {
      event: {
        eventInfo: {
          eventAction: "page load",
          eventName: "generic",
          eventType: "page"
        },
        category: {
          primaryCategory: "calculator"
        },
        attributes: {
          linkText: "",
          currentURL: window.location.href,
          targetURL: "",
          elementName: "",
          value: "",
          pos: "",
          componentPath: "",
          clickID: ""
        }
      }
    };
    // @ts-ignore
    window.digitalDataLayer.push(dataLayerEvent);
  }

  trackLinkClick(_intern: boolean, _position: string, _href: string, innerText: string) {
    var dataLayerEvent = {
      event: {
        eventInfo: {
          eventAction: (_intern) ? "internal link" : "external link",
          eventName: (_position == 'header') ? "click on header" : "click on footer",
          eventType: "trigger"
        },
        category: {
          primaryCategory: ""
        },
        attributes: {
          linkText: innerText,
          currentURL: window.location.href,
          targetURL: _href,
          elementName: "text link",
          value: "",
          pos: "",
          componentPath: _position,
          clickID: ""
        }
      }
    };
    // console.warn('--->dataLayerEvent', dataLayerEvent);
    // @ts-ignore
    window.digitalDataLayer.push(dataLayerEvent);
  }
}
